import React, { Fragment, Component } from 'react';
import styled, { css } from 'styled-components';

import LandingBase from './LandingBase';
import { breakpoints, flexRow, palette } from '../../constants/styles';
import Helmet from 'react-helmet';
import Title from '../shared/Title';
import Section from './Section';
import Island from '../shared/Island';
import TLDRFinauta from '../shared/TLDRFinauta';
import Text from '../shared/Text';
import { Link } from 'react-router-dom';
import Button from '../shared/Button';
import Wistia from '../shared/Wistia';
import Modal from '../shared/Modal';
import { mp } from '../../constants/utils';
import descuento from '../../images/png/descuento.png';
import Icon from '../shared/Icon';
import { StyledCustomDivision } from '../shared/resultsStyles';
import { PENSION_PLAN_PRICE, DISCOUNTED_PENSION_PLAN_PRICE } from '../../constants/constants';
import VideoPlayer from '../PilarPages/VideoPlayer';

const StyledTitle = css`
  max-width: 400px;

  ${breakpoints.tablet} {
    text-align: center;
  }

  ${breakpoints.tabletLandscape} {
    text-align: left;
  }
`;

export const StyledResultImageExamplePlan = styled.img`
  align-self: flex-end;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  margin-top: 50px;
  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }
`;

const StyledResultImage = styled.img`
  align-self: flex-end;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
`;

export const StyledCustomHr = styled.hr`
  display: block;
  width: 90%;
  max-width: 600px;
  height: 0px;
  margin-top: 20px;
  border-top: 1px solid ${palette.primaryColor}2b;
  border-bottom: none;
`;

const StyledSobreFinauta = css`
  margin-top: 80px;
  margin-bottom: 20px;

  ${breakpoints.mobileLandscape} {
    margin-top: 130px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }

  ${breakpoints.desktop} {
    margin-top: 100px;
  }
`;

export const StyledFirstButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0px 20px;
`;

const StyledDiscountContainer = styled.div`
  ${flexRow}
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
`;

const StyledDiscountedPrice = css`
  font-size: 1.8rem;
  line-height: 1;
  margin-right: 10px;
  text-decoration: line-through;
  -webkit-text-decoration-color: #f00a0a;
  text-decoration-color: #f00a0a;
`;

const StyledNewPrice = css`
  font-size: 2.5rem;
  line-height: 1;
`;

const StyledIntroductionText = styled.div`
  max-width: 500px;
`;

export const StyledButtonA = styled.a`
  width: 250px;
  margin-bottom: 20px;
  text-decoration: none;
`;

const StyledButtonLink = styled(Link)`
  width: 250px;
  margin-bottom: 20px;
  text-decoration: none;
`;

export const StyledLink = styled(Link)`
  width: 250px;
  text-decoration: none;
`;

const Discount = styled.img.attrs({
  src: descuento,
})`
  position: relative;
  top: -20px;
  right: -15px;
  height: 40px;
  width: 40px;
`;

const VideoPlayerContainer = styled.div`
  margin-top: 10px;
  align-self: center;
  margin-bottom: 20px;
  width: 280px;

  ${breakpoints.tablet} {
    margin-bottom: 30px;
    width: 500px;
  }

  ${breakpoints.desktop} {
    margin-bottom: 40px;
    width: 650px;
  }
`;

const StyledVideoContainer = styled.div`
  width: 60%;
`;

class ReferalLanding extends Component {
  componentDidMount() {}
  render() {
    const { referralId } = this.props.match.params;
    return (
      <Fragment>
        <Helmet>
          <title>{'Finauta | Retiro'}</title>
        </Helmet>
        <LandingBase landingName="Referral">
          <Section>
            <StyledResultImageExamplePlan
              src={`https://s3.us-east-2.amazonaws.com/finauta/products/pdf-preview.png`}
            />
            <Title level={3}>Plan de pensión</Title>
            <StyledDiscountContainer>
              <Discount />
              <Text type="body2" styles={StyledDiscountedPrice}>
                ${PENSION_PLAN_PRICE}
              </Text>
              <Text type="body2" styles={StyledNewPrice} medium>
                ${DISCOUNTED_PENSION_PLAN_PRICE}
              </Text>
            </StyledDiscountContainer>
            <StyledButtonA target="_blank" href="https://www.youtube.com/watch?v=dfs1OF0bSYk">
              <Button
                styles={StyledFirstButton}
                onClick={() => {
                  mp('Referrals | CTA | PlanDeEjemplo');
                }}
                color="darkerGray"
              >
                <Text type="buttonText" color="white" bold>
                  Ver plan de ejemplo
                </Text>
                {/* <Icon icon="playVideo" color="white" size={25} style={{ marginLeft: '10px' }} /> */}
              </Button>
            </StyledButtonA>
            <StyledLink
              to={`/retiro/contacto/5989130/3b65300c-f2e0-4264-b413-e46c70835976/${referralId}`}
            >
              <Button
                styles={StyledFirstButton}
                onClick={() => {
                  mp('Referrals | CTA | Solicitar plan');
                }}
              >
                <Text type="buttonText" style={{ marginRight: '10px' }} color="white" bold>
                  ${DISCOUNTED_PENSION_PLAN_PRICE}
                </Text>
                <Text type="buttonText" color="white" bold>
                  Solicitar plan
                </Text>
              </Button>
            </StyledLink>
          </Section>
          <StyledCustomHr />
          <Section>
            <Title level={3} style={{ marginBottom: '20px' }}>
              ¿Qué es un plan de pensión?
            </Title>
            <VideoPlayerContainer>
              <VideoPlayer url="https://www.youtube.com/watch?v=KwkyvILxRpI" />
            </VideoPlayerContainer>
          </Section>
          <StyledCustomHr />
          <Section>
            <Title level={3} style={{ marginBottom: '20px' }}>
              Calculadora de pensión
            </Title>
            <StyledResultImage
              src={`https://s3.us-east-2.amazonaws.com/finauta/tools/retiro.jpg`}
            />
            <Text type="body1" style={{ marginBottom: '20px' }} medium>
              Descubre con cuánto te retirarás
            </Text>
            <StyledButtonLink to={`/retiro/empezar/${referralId}`}>
              <Button
                styles={StyledFirstButton}
                onClick={() => {
                  mp('Referrals | CTA | Utilizar herramienta');
                }}
                color="primary"
              >
                <Text type="buttonText" color="white" medium>
                  Utilizar herramienta
                </Text>
              </Button>
            </StyledButtonLink>
          </Section>

          <Section>
            <Island type="referalLanding" />
            <TLDRFinauta />
          </Section>
        </LandingBase>
      </Fragment>
    );
  }
}

export default ReferalLanding;
